export default [{
        title: "首页",
        permission: "home",
        icon: "el-icon-s-home",
        to: "/dashboard/index",
        children: []
    },
    {
        title: "应用中心",
        permission: "app",
        icon: "el-icon-connection",
        to: "/app/index",
    },
    {
        title: "鉴权记录",
        permission: "auth",
        icon: "el-icon-takeaway-box",
        to: "/auth/index"
    },
    {
        title: "日志记录",
        permission: "log",
        icon: "el-icon-document",
        to: "/log/index",
    },
    {
        title: "用户管理",
        permission: "user",
        icon: "el-icon-user",
        to: "/user/index"
    },
    // {
    //     title: "系统配置",
    //     permission: "system",
    //     icon: "el-icon-setting",
    //     to: "/system",
    //     children: [{
    //             title: "系统日历封面",
    //             permission: "system.calendar",
    //             icon: "el-icon-picture-outline-round",
    //             to: "/system/calendar"
    //         },
    //         // {
    //         //     title: "引导视频设置",
    //         //     permission: "system.video",
    //         //     icon: "el-icon-video-camera-solid",
    //         //     to: "/system/video"
    //         // },
    //         {
    //             title: "系统用户管理",
    //             permission: "system.manager",
    //             icon: "el-icon-s-custom",
    //             to: "/system/manager"
    //         }
    //     ]
    // }
]